module.exports = __webpack_public_path__ + "img/faro-resort.4676880f.jpg";